import React from 'react';
import { styles } from './BackOrderMessaging.css';
import { BACK_ORDER_ALERT } from '../constants';

export const BackOrderMessaging = () => {
  return (
    <div data-test-id="back-order-messaging" className={styles.container}>
      <h2 className={styles.heading}>{BACK_ORDER_ALERT.heading}</h2>
      <div>{BACK_ORDER_ALERT.subheader}</div>
      <div>
        {BACK_ORDER_ALERT?.content?.split('\n').map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </div>
    </div>
  );
};
